export class StockInDTO{
  id: number;
  modelId: number;
  pointTypeId: number;
  sizeId: number;
  quantity: number;
  machineId?: number;
  isActive?: boolean;
  createdAt?: Date;
  createdUser?: string | null;
  updatedAt?: Date;
  updatedUser?: string | null;
  versionFlag?: number;

  constructor(
    id: number,
    modelId: number,
    pointTypeId: number,
    sizeId: number,
    quantity: number,
    isActive?: boolean,
    machineId?: number,
    createdAt?: Date,
    createdUser?: string | null,
    updatedAt?: Date,
    updatedUser?: string | null,
    versionFlag?: number,
    
  ){
    this.id = id;
    this.modelId = modelId;
    this.pointTypeId = pointTypeId;
    this.sizeId = sizeId;
    this.quantity = quantity;
    this.isActive = isActive;
    this.machineId = machineId;
    this.createdAt = createdAt;
    this.createdUser = createdUser;
    this.updatedAt = updatedAt;
    this.updatedUser = updatedUser;
    this.versionFlag = versionFlag;
  }


}
